import React from 'react';
import './App.css'; 
import RoomCanvas from './RoomCanvas';
import RoomDetails from './RoomDetails';

function App() {
  return (
    <div>
      <RoomCanvas />

      <RoomDetails roomName="Mes projets" description="Salut ! mes projets sont afficher au mur, jette un oeil sur l'ordinateur aussi !" />
    </div>
  );
}

export default App;
